import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from 'src/app/shared/guard/admin.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExtratoComponent } from './extrato/extrato.component';
import { CommissionsComponent } from './commissions/commissions.component';
import { AccountComponent } from './account/account/account.component';
import { ViewAccountComponent } from './account/view-account/view-account.component';
import { CryptomoedaComponent } from './cryptomoeda/cryptomoeda.component';
import { DepositComponent } from './deposit/deposit/deposit/deposit.component';
import { DepositPixComponent } from './deposit/depositPix/depositPix/depositPix.component';
import { CashInComponent } from './deposit/cashIn/cashIn/cashIn.component';
import { TransferenciaComponent } from './transferencia/transferencia/transferencia/transferencia.component';
import { SaqueCopiaColaComponent } from './transferencia/saque-copia-cola/saque-copia-cola/saque-copia-cola.component';
import { TransferBalanceComponent } from './transfer-balance/transfer-balance.component';
import { WalletComponent } from './wallet/wallet.component';
import { UserConfigComponent } from './user-config/user-config.component';
import { WebhookComponent } from './webhook/webhook.component';
import { ApproveComponent } from './withdraw/approve/approve.component';
import { ApproveadminComponent } from './withdraw/approveadmin/approveadmin.component';
import { ContentLayoutComponent } from '../shared/layout-components/layout/content-layout/content-layout.component';
import { OriginGuard } from '../shared/guard/origin.guard';
import { ReservaGgrComponent } from './reserva-ggr/reserva-ggr/reserva-ggr.component';
import { ReserveAccountGuard } from '../shared/guard/reserve-account.guard';
import { SplitGuard } from '../shared/guard/split.guard';
import { CryptoDepositComponent } from './crypto-deposit/crypto-deposit.component';
import { CryptoGuard } from '../shared/guard/crypto.guard';
import { SummaryComponent } from './summary/summary.component';
import { SubAccountsComponent } from './sub-accounts/sub-accounts.component';
import { SaqueBoletoComponent } from './transferencia/saque-boleto/saque-boleto/saque-boleto.component';
import { InfractionsComponent } from './infractions/infractions.component';
import { PublicLayoutComponent } from '../shared/layout-components/layout/public-layout/public-layout.component';
import { ExternalCashInComponent } from './deposit/externalCashIn/externalCashIn.component';
import { ExternalCashOutComponent } from './transferencia/externalCashOut/externalCashOut.component';
import { CommissionsWalletComponent } from './commissions-wallet/commissions-wallet.component';
import { ApiCredentialsComponent } from './api-credentials/api-credentials.component';
import { CheckoutConfig } from './checkout-config/checkout-config.component';
import { CheckoutConfigGuard } from '../shared/guard/checkout-config.guard';

// const isDesktop(): boolean => {
//   return navigator.orientation === undefined;
// }



const routes: Routes = [
  {
    path: 'external',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'cashin',
        title: 'Cash In',
        component: ExternalCashInComponent,
      },
      {
        path: 'cashout',
        title: 'Cash Out',
        component: ExternalCashOutComponent,
      },
    ],
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        data: { mode: 'dark' },
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'sub-accounts',
        title: 'Subcontas',
        component: SubAccountsComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'api-credentials',
        title: 'Credenciais API',
      component: ApiCredentialsComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'extrato',
        title: 'Extrato',
        component: ExtratoComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'resumo',
        title: 'Resumo',
        component: SummaryComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'infracoes',
        title: 'Infrações',
        component: InfractionsComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'comissoes',
        title: 'Comissões',
        component: CommissionsComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'carteira-comissoes',
        title: 'Carteira',
        component: CommissionsWalletComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'checkout-config',
        title: 'Checkout',
        component: CheckoutConfig,
        canActivate: [AdminGuard, CheckoutConfigGuard],
      },

      {
        path: 'reserva-financeira',
        title: 'Reserva Financeira',
        component: ReservaGgrComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'transferencia',
        title: 'Transferência',
        component: TransferenciaComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'saque-copia-cola',
        title: 'Saque Copia e Cola',
        component: SaqueCopiaColaComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'saque-boleto',
        title: 'Saque Boleto',
        component: SaqueBoletoComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'transfer-balance',
        title: 'Transferir Saldo',
        component: TransferBalanceComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'criptomoeda',
        title: 'Criptoativos',
        component: CryptomoedaComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'cripto',
        title: 'Conversão Cripto',
        component: CryptoDepositComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'deposito',
        title: 'Depósito',
        component: DepositComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'depositoPix',
        title: 'Depósito Pix',
        component: DepositPixComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'cashIn',
        title: 'Cash In',
        component: CashInComponent,
        canActivate: [AdminGuard, OriginGuard, CryptoGuard],
        data: { excludedOrigins: ['BRL'] }
      },
      {
        path: 'account/view',
        title: 'Visualização da Conta',
        component: ViewAccountComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'wallet',
        title: 'Carteira',
        component: WalletComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'user-config',
        title: 'Configurações',
        component: UserConfigComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'account/account',
        title: 'Contas',
        component: AccountComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'webhook',
        title: 'WebHook',
        component: WebhookComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'approve-withdraw',
        title: 'Aprovar Saques',
        component: ApproveComponent,
        canActivate: [AdminGuard, CryptoGuard],
      },
      {
        path: 'approve-withdraw-admin',
        title: 'Aprovar Saques',
        component: ApproveadminComponent,
        canActivate: [AdminGuard,CryptoGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule],
})
export class ComponentsRouteModule {}
